const defaultFonts = {
    "font-family": "Poppins, sans-serif",
};

const astara = {
    "font-family": "Montserrat, sans-serif",
};

const themeFonts = {
    carconnex: {
        ...defaultFonts,
    },
    astara: {
        ...defaultFonts,
        ...astara,
    },
};

export default themeFonts;
